import { render, staticRenderFns } from "./ticket.vue?vue&type=template&id=a6712228&scoped=true&"
import script from "./ticket.vue?vue&type=script&lang=js&"
export * from "./ticket.vue?vue&type=script&lang=js&"
import style0 from "./ticket.vue?vue&type=style&index=0&id=a6712228&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6712228",
  null
  
)

export default component.exports